var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isolate"},[_c('h1',[_vm._v("画面切替")]),_vm._v(" "),_c('ul',{staticClass:"tab-menu-base"},[_c('li',[_c('router-link',{attrs:{"to":"/gourmet/check"}},[_vm._v("投稿内容確認")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/gourmet/alert"}},[_vm._v("お知らせ内容確認登録")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5193cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/isolate.vue
// module id = null
// module chunks = 